import React, { Component, Fragment } from "react";
import { fetchPayouts, updatePayoutStatus } from "../actions/payouts";
import { connect } from "react-redux";
import Notification from "../components/structure/Notification";
import { Overlay } from "clorian-frontend-components";
import { DateRangePicker } from "react-dates";
import "../resources/stylesheets/payouts.css";
import { getTableColumns } from "../table-management/payout-table/table-configs";
import { TableContainer } from "../components/structure/TableContainer";
import { getTableOptions } from "../table-management/payout-table/table-configs";

class PayoutsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payoutList: [],
      initialPayoutList: [],
      view: "all",
      showNotification: false,
      notification: {
        status: "",
        message: "",
        title: "",
        startDate: null,
        endDate: null,
      },
    };
    this.changePayoutStatus = this.changePayoutStatus.bind(this);
    this.handlePayoutPaid = this.handlePayoutPaid.bind(this);
    this.changeDates = this.changeDates.bind(this);
  }

  changePayoutStatus = (event) => {
    const { startDate, endDate } = this.state;
    this.manageFilters(startDate, endDate, event.target.value);
  };

  componentDidMount() {
    const { currentAffiliate } = this.props;

    if (currentAffiliate) {
      this.getPayouts(currentAffiliate.affiliateId);
    }
  }

  getPayouts(currentAffiliateId) {
    const { dispatch } = this.props;
    dispatch(fetchPayouts(currentAffiliateId)).then(({ response }) => {
      if (response) {
        this.setState({
          payoutList: response,
          initialPayoutList: response,
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentAffiliate &&
      this.props.currentAffiliate &&
      prevProps.currentAffiliate.affiliateId !==
        this.props.currentAffiliate.affiliateId
    ) {
      this.getPayouts(this.props.currentAffiliate.affiliateId);
    }
  }

  handlePayoutPaid(payoutId, payoutTotal) {
    const { dispatch, currentAffiliate } = this.props;

    dispatch(
      updatePayoutStatus(
        payoutId,
        payoutTotal.toFixed(2),
        currentAffiliate.affiliateId
      )
    ).then(({ response }) => {
      if (response) {
        this.setState({
          showNotification: true,
          notification: {
            status: "success",
            message: "Success",
            title: "Success",
          },
        });
      } else {
        this.setState({
          showNotification: true,
          notification: {
            status: "danger",
            message: "Error",
            title: "Oops, something has gone wrong. Please try again",
          },
        });
      }
      this.getPayouts(currentAffiliate.affiliateId);
    });
  }

  changeDates({ startDate, endDate }) {
    const { view } = this.state;
    this.manageFilters(startDate, endDate, view);
  }

  manageFilters(startDate, endDate, view) {
    const { initialPayoutList } = this.state;
    let payouts = initialPayoutList;

    if (startDate && endDate) {
      payouts = initialPayoutList.filter((p) => {
        if (
          new Date(p.creationDate) >= startDate.startOf("day") &&
          new Date(p.creationDate) <= endDate.endOf("day")
        )
          return p;
        return false;
      });
    }

    if (view !== "all") payouts = payouts.filter((p) => p.status === view);

    this.setState({
      startDate,
      endDate,
      payoutList: payouts,
      view,
    });
  }

  render() {
    const { isProcessing, currency } = this.props;
    const { view, showNotification, notification, payoutList } = this.state;
    const tableColumns = getTableColumns(this.handlePayoutPaid, view, currency);
    const tableOptions = getTableOptions();

    const options = [
      { value: "all", label: "All" },
      { value: "pending_payment", label: "Pending" },
      { value: "paid", label: "Paid" },
    ];

    return (
      <div className="container">
        {showNotification && <Notification notification={notification} />}

        {isProcessing ? (
          <Overlay noClorian={true} loading={true} />
        ) : (
          <Fragment>
            <div className="row mainBody">
              <div className="form-custom">
                <div className="col-xs-12 col-sm-12 col-lg-6">
                  <label className=""> Select payment status :</label>
                  {/*                    <Select defaultValue={options[0]} className="payoutSelect" options={options}
                              onChange={this.changePayoutStatus}/>*/}
                  <select
                    className="form-control"
                    value={view}
                    onChange={this.changePayoutStatus}
                  >
                    {options.map((option) => (
                      <option
                        key={`option-${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xs-12 col-sm-12 col-lg-6">
                  <label className="">Select Period :</label>
                  <DateRangePicker
                    startDate={this.state.startDate}
                    startDateId="your_unique_start_date_id"
                    endDate={this.state.endDate}
                    endDateId="your_unique_end_date_id"
                    onDatesChange={({ startDate, endDate }) =>
                      this.changeDates({ startDate, endDate })
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    isOutsideRange={() => false}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="custom-table block">
                <TableContainer
                  columns={tableColumns}
                  data={payoutList}
                  options={tableOptions}
                />
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { payouts, affiliates, clients } = state;
  const { clientList } = clients;
  let clientIndex = clientList.findIndex(
    (el) => el.clientId === affiliates.currentAffiliate.clientId
  );
  const sCurrency =
    clientIndex !== -1
      ? clientList[clientIndex].currencyList[0].isoCode
      : "EUR";

  return {
    currentAffiliate: affiliates.currentAffiliate,
    isProcessing: payouts.isProcessing,
    currency: sCurrency,
  };
};

export default connect(mapStateToProps)(PayoutsContainer);
